import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadphones } from '@fortawesome/free-solid-svg-icons';
import styles from '../SoundGenerator.module.css';

interface NewSoundProjectButtonProps {
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
}

const NewSoundProjectButton: React.FC<NewSoundProjectButtonProps> = ({
  onClick,
  loading = false,
  disabled = false,
  className = ''
}) => {
  const { t } = useTranslation('soundGenerator');
  
  return (
    <Button
      className={`${styles.soundButton} ${className}`.trim()}
      size="lg"
      variant="outline"
      onClick={onClick}
      loading={loading}
      disabled={disabled}
      leftSection={<FontAwesomeIcon icon={faHeadphones} />}
    >
      {t('hero.newProjectButton')}
    </Button>
  );
};

export default NewSoundProjectButton;
